.facebook-post {
  text-align: center;

  /* stylelint-disable-next-line selector-pseudo-class-no-unknown */
  :global(.fb-post) {
    background-color: var(--palette-background-primary);
  }
}
